import React, { Component } from 'react';
import { connect } from 'react-redux';
import preventBack from '../hoc/preventBack';
import { resetSessionData, resetTime } from '../store/globals';
import localSessionStorage from '../services/localSessionStorage';
import { check_os } from "../helpers";
import TagManager from 'react-gtm-module';
import QRCode from "qrcode.react";
import { selectedSeatsHumanSelector } from '../selectors/index';
import { getAppleWallet, clearPaymentResponse } from "../store/payments";

class PaymentSuccess extends Component {

  constructor(props) {
    super(props);

    this.validateTgm = false;
  }

  componentDidMount() {
    const scriptAds = document.createElement("script");

    if (this.props.paymentResponse && typeof this.props.paymentResponse.tickets_confirmation === 'undefined') {      
        this.props.history.push('/error');
    }

    if (this.validateTgm === false) {
      const { showtime, ticket, paymentResponse, seatsResponse, cityName, textselectedSeats, folio, payments, bill_to } = this.props;
      let products = [];
      let i = 1;
      let caterogories = '';
      for (let item of ticket.selectedTickets) {
        let category = '';
        let price;
        for (let areaItem of ticket.tickets.areas) {
          let area = areaItem.tickets.find(c => c.code === item.ticket_type_code);
          if (typeof area !== 'undefined') {
            caterogories += caterogories !== '' ? ', ' + (typeof area.description !== 'undefined' ? area.description : typeof area.name !== 'undefined' ? area.name : '') : '';
            category = area.description;
            price = area.price / 100
          }
        }

        let product = {
          item_id: i.toString() + ticket.tickets.session_id + showtime.showtimes.datetime.split('T')[1].replace(/:/g, ""),
          item_name: showtime.movie.name.replace(` ${showtime.movie.format}`,''),
          seat: showtime.movie.seat,
          item_city: cityName,
          item_brand: showtime.movie.distributor, //distribuidora 
          item_category: "boleto",
          item_category2: category,
          item_category3: "NA",
          item_category4: "NA",
          movie_date: showtime.showtimes.datetime.split('T')[0].replaceAll("-", " "),
          movie_time: showtime.showtimes.datetime.split('T')[1],
          item_cinema: showtime.cinema.name,
          seat: textselectedSeats,
          item_language: showtime.movie.language,
          price: price,
          quantity: item.quantity,
          item_age: showtime.movie.rating,
          item_sala: showtime.movie.format
        };
        products.push(product);
        i++;
      }
      const tagManagerArgs2 = {
        dataLayer: {
          event: 'purchase',
          ecommerce: {
            currency: "EUR",
            transaction_id: 'T' + Date.now().toString() + paymentResponse.tickets_confirmation.booking_id,
            value: parseFloat(seatsResponse.total_value.slice(0, -2) + "." + seatsResponse.total_value.substr(-2)),
            coupon: folio,
            payment_type: payments.type ? payments.type : '',
            Affiliation: 'Canal Web',
            tax: 2.00, 
            items: [...products],
          }
        }
      };
      const tagManagerArgs = {
        dataLayer: {
          item_name: this.props.showtime.movie.name,
          event: "pageView",
          path: '/visConfirmation'
        }
      };
      const clienfInfoEventArgs = {
        dataLayer: {
          event: "client_info",
          page_name: "/confirmacion",
          transaction_id: 'T' + Date.now().toString() + paymentResponse.tickets_confirmation.booking_id,
          email_address: bill_to?.email,
          last_name: bill_to?.last_name,
          first_name: bill_to?.first_name,
        }
      }
      TagManager.dataLayer(tagManagerArgs2);
      TagManager.dataLayer(tagManagerArgs);
      TagManager.dataLayer(clienfInfoEventArgs);
      this.validateTgm = true;
    }
    this.props.resetTime();

    scriptAds.innerText = `googletag.cmd.push(function() { googletag.display('div-gpt-ad-1666298843863-0'); });`;
    scriptAds.async = true;
    document.body.appendChild(scriptAds);
  }

  printBookingId = () => {
    const { paymentResponse } = this.props;

    if ((paymentResponse && typeof paymentResponse.status_code !== 'undefined' && paymentResponse.status_code === 0) ||
      (this.statusCode && parseInt(this.statusCode, 10) === 0)) {
      return <div className="success__code">
        {<div className="codigo-qr">
          <QRCode value={paymentResponse.tickets_confirmation
            ? paymentResponse.tickets_confirmation.booking_id
            : this.ticketsConfirmation} size={"200"} level="Q" />
        </div>
        }
        {paymentResponse.tickets_confirmation
          ? paymentResponse.tickets_confirmation.booking_id
          : this.ticketsConfirmation
        }
      </div>;
    }

    return null;
  };

  goToHome = () => {
    localSessionStorage.clear();
    this.props.resetSessionData();
  };

  appleWallet = () => {
    var pass = {
      data: {
        booking_id: this.props.paymentResponse.tickets_confirmation.booking_id,
        booking_token: this.props.sessionId,
        cinema_vista_id: this.props.cinemaVistaId,
        passbok_type: 'EventTicket',
        booking_number: this.props.paymentResponse.tickets_confirmation.booking_number,
        credit_card: '',
        platform_version: "1",
        pay_method: "C"
      },
      event_ticket: {
        room: this.props.showtime.showtimes.screen,
        seating: {
          identify: this.props.textselectedSeats
        },
        movie: {
          name: this.props.showtime.movie.original_name,
          image_thumb: this.props.showtime.movie.url_poster,
          image_thumb_retina: this.props.showtime.movie.url_poster
        },
        movie_projection_date: this.props.showtime.showtimes.datetime,
        cinema: {
          name: this.props.showtime.cinema.name,
          latitude: "0",
          longitude: "0"
        }
      }
    }
    const data = this.props.getAppleWallet(pass);
  }

  render() {
    const { isMobile } = this.props;

    return (
      <div className="success">
        <h1 className="title">¡Gracias por elegirnos!</h1>
        <div id='div-gpt-ad-1666298843863-0' style={{width: 'auto', minHeight: '187px'}}></div>
        <div className="texts">
          <p className="text">Tus entradas han sido enviadas al correo electrónico que nos proporcionaste.</p>
        </div>


        {this.printBookingId()}

        {check_os() && <div className="btn-wallet">
          <button className="btn" onClick={this.appleWallet}><img src={require("../static/images/icon-wallet.png")} alt="" /> Agregar a Apple Wallet</button>
        </div>}

        <a href="https://yelmocines.es/" onClick={this.goToHome} className="btn btn--primary">IR AL INICIO</a>
      </div>
    );
  }
}

const mapStateToProps = ({ payments, ui, showtime, tickets, seats, globals, cards, locations }) => {
  
  let cityName = ''
  if(locations && locations.cities) {
    const currentCity = locations.cities.find(city => {
      const hasCurrentCinema = city?.cinemas.find(cinema => cinema.vista_id === showtime.cinema.vista_id)
      return hasCurrentCinema
    })
    cityName = currentCity?.name
  }

  return {
    bill_to: payments.bill_to,
    paymentResponse: payments.paymentResponse,
    payments,
    isMobile: ui.isMobile,
    showtime,
    ticket: tickets,
    folio: cards.folio,
    seatsResponse: seats.seatsSelectedResponse,
    sessionId: globals.sessionId,
    cinemaVistaId: globals.cinemaVistaId,
    textselectedSeats: selectedSeatsHumanSelector({
      ui,
      payments, globals, tickets, seats, showtime
    }),
    cityName
  }
}

export default preventBack(connect(mapStateToProps,
  { resetSessionData, resetTime, getAppleWallet, clearPaymentResponse }
)(PaymentSuccess));
